/**
 * SaveFavouriteHashTagsUseCase
 *
 * Saves used hashtags to SecureStorage for local favourites.
 * Each tag is stored individually (keyed by name) with incremented localUses.
 * Matches Flutter's ContentTagsRepository.saveFavouriteHashTags.
 */

import type { ContentTagEntity } from '@/domain/entities/contentTag/contentTagEntity';
import { SecureStorageWebCrypto } from '@/data/storage/local/secureStorageWebCrypto';
import { SECURE_STORAGE_KEYS } from '@/domain/entities/secureStorage/secureStorageKeys';

export class SaveFavouriteHashTagsUseCase {
  private storage: SecureStorageWebCrypto;

  constructor(storage?: SecureStorageWebCrypto) {
    this.storage = storage ?? SecureStorageWebCrypto.getInstance();
  }

  async execute(contentTags: ContentTagEntity[]): Promise<void> {
    if (contentTags.length === 0) return;

    for (const contentTag of contentTags) {
      const key = SECURE_STORAGE_KEYS.FAVOURITE_HASHTAGS + contentTag.name;
      const existing = await this.storage.getEncrypted<ContentTagEntity>(key);

      const tagToSave: ContentTagEntity = {
        ...contentTag,
        localUses: existing ? existing.localUses + 1 : contentTag.localUses,
      };

      await this.storage.setEncrypted(key, tagToSave);
    }
  }
}

export const createSaveFavouriteHashTagsUseCase = () => new SaveFavouriteHashTagsUseCase();
